//
// Copyright (c) 2011-2026 by Curalate, Inc.
//

import { theme } from '@bvengineering/unison-core';
import angular from 'angular';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import styled from 'styled-components';

import { RequiredPermissionsButton } from '@components/atoms/required-permissions-button/RequiredPermissionsButton';
import { BulkRejectConfirmationModal } from '@media-library/ai-content-curation/components/BulkRejectConfirmationModal';
import { AiContentCurationTrackingIds } from '@media-library/ai-content-curation/constants/AiContentCurationTrackingIds';
import { useAiContentCurationBulkRejectMutation } from '@media-library/queries';
import { ICuralateStore } from '@models/AppState';
import { Permissions } from '@models/Permissions';
import makeAngularReactController from '@react-bridge/angular-react-widget';

export const BulkActionsBulkReject = () => {
  const [isBulkRejectModalOpen, setIsBulkRejectModalOpen] = useState(false);

  const selectedItems = useSelector(
    (state: ICuralateStore) => state.bulkActions.selectedItems,
  );

  const { isPending: isRejecting, mutate: bulkReject } =
    useAiContentCurationBulkRejectMutation();

  const onConfirmReject = () => {
    setIsBulkRejectModalOpen(false);
    bulkReject(selectedItems);
  };

  return (
    <>
      <RejectButton
        iconName='close'
        isDisabled={selectedItems.length === 0 || isRejecting}
        onClick={() => setIsBulkRejectModalOpen(true)}
        permissionName={Permissions.FanreelModerate}
        trackingId={AiContentCurationTrackingIds.BULK_REJECT_BUTTON}
      >
        Reject
      </RejectButton>
      <BulkRejectConfirmationModal
        isOpen={isBulkRejectModalOpen}
        itemCount={selectedItems.length}
        onCancel={() => setIsBulkRejectModalOpen(false)}
        onConfirm={onConfirmReject}
      />
    </>
  );
};

const RejectButton = styled(RequiredPermissionsButton).attrs({
  buttonStyles: {
    fixed: {
      fontWeight: 'bold',
      borderShape: 'pill',
      borderThickness: 'thick',
    },
    standard: {
      color: theme.colors.white,
      backgroundColor: theme.colors.aliases.primary,
      borderColor: theme.colors.white,
    },
    hover: {
      color: theme.colors.aliases.primary,
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.white,
    },
    active: {
      color: theme.colors.aliases.primary,
      backgroundColor: theme.colors.white,
      borderColor: theme.colors.white,
    },
    disabled: {
      color: theme.colors.gray4,
      backgroundColor: theme.colors.gray0,
      borderColor: theme.colors.gray0,
    },
  },
})(
  ({ theme }) => `
  margin-right: ${theme.spacings[4]};
  height: 100%;
  box-shadow: none;
  border: ${theme.borderWidths[2]} solid ${theme.colors.white};
`,
);

angular.module('curalate').component('bulkActionsBulkReject', {
  controller: makeAngularReactController(<BulkActionsBulkReject />),
});
